import { defineBoot } from '#q-app';

export interface AppConfig {
  api: {
    baseUrl: string;
    timeout: number;
  };
  environment: string;
  upload: {
    maxFileSizeBytes: number;
    maxFileSizeMB: number;
    maxBatchFiles: number;
  };
}

// TRANSPORT ceiling — the request-size bound below which nginx/PHP accept the
// multipart POST. The one API image (deployed local/test/prod alike) sets
// client_max_body_size=80M (api/docker/nginx/nginx.conf) and
// upload_max_filesize=post_max_size=80M (api/docker/php/php-fpm-config.ini).
// App-level per-tier caps live in src/utils/uploadLimits.ts and are clamped to
// this ceiling; keep this constant in sync with the server config.
const MAX_FILE_SIZE_MB = 80;
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024; // 64MB in bytes

// Maximum number of files accepted in a single multi-file upload (photos, media, documents)
const MAX_BATCH_FILES = 8;

// Create a type-safe config object with default values
// This ensures config is never undefined even before boot runs
const config: AppConfig = {
  api: {
    baseUrl: import.meta.env.VITE_API_URL ?? '',
    timeout: import.meta.env.VITE_API_TIMEOUT ?? 60000,
  },
  environment: import.meta.env.VITE_APP_ENV ?? '',
  upload: {
    maxFileSizeBytes: MAX_FILE_SIZE_BYTES,
    maxFileSizeMB: MAX_FILE_SIZE_MB,
    maxBatchFiles: MAX_BATCH_FILES,
  },
};

export default defineBoot(({ app }) => {
  // Make config available globally
  app.config.globalProperties.$config = config;
  app.provide('config', config);
});

// Export the config for direct imports
export { config };
